import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './assets/common.less'
import i18n from '@/locales'

Vue.config.productionTip = false

new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')

fnResize()
window.onresize = function () {
  fnResize()
}
function fnResize () {
  document.documentElement.style.fontSize = 14 + 'px'
}
